import { SEOHead } from '../components/seo/SEOHead';
import { buildBreadcrumbSchema } from '../lib/seo-utils';

const SECTIONS = [
  {
    title: 'Services Provided',
    body: 'Bharat Consultancy provides tax filing, business registration, licensing, and compliance-related consultancy services. We act as your representative in preparing and submitting applications to government authorities, but final approval of any registration, license, or filing rests with the relevant government department and is outside our control.',
  },
  {
    title: 'Payments',
    body: 'Full service pricing is not published on this website. After you book and pay for a 30-minute consultation, we discuss your specific requirement and provide a personalized quotation with tax shown separately, before any further payment is requested. See "Refund Policy" below for how refunds are handled.',
  },
  {
    title: 'Client Responsibilities',
    body: 'You are responsible for providing accurate, complete, and genuine documents and information. Bharat Consultancy is not liable for delays, rejections, or penalties arising from incorrect, incomplete, or fraudulent information or documents provided by you.',
  },
  {
    title: 'Consultation Bookings',
    body: 'The paid 30-minute consultation call is a discussion service to assess your requirement and provide a quotation. It does not constitute a binding service agreement, and payment for the call does not obligate you to purchase any further service from us.',
  },
  {
    title: 'Privacy & Data Use',
    body: 'We collect the personal and business information necessary to complete your requested service (identity documents, business details, contact information). This information is used solely for fulfilling your service, generating invoices, and providing account access via your customer dashboard. We do not sell your personal information to third parties.',
  },
  {
    title: 'Data Storage & Security',
    body: 'Documents you upload are stored securely and access is restricted to staff assigned to your case. You may request deletion of your account and associated documents by contacting us directly, subject to any legal retention requirements for filed tax and compliance records.',
  },
  {
    title: 'Communication',
    body: 'By using our services, you consent to receive service-related communication via email, SMS, phone, and WhatsApp regarding your order status, document requests, and payment confirmations.',
  },
  {
    title: 'Refund Policy',
    body: 'The ₹499 consultation fee is non-refundable once the call has taken place, since it covers the consultant\u2019s time and advice given. If you cancel before the scheduled call, contact us and we will review a refund on a case-by-case basis. For any full service booked after a consultation, refund terms will be communicated to you directly as part of your quotation before you pay, since fees vary by service and by the government charges involved.',
  },
  {
    title: 'Disclaimer',
    body: 'Bharat Consultancy provides professional consultancy and documentation assistance; we are not a government body and do not guarantee approval, issuance, or timelines for any registration, license, or filing, as these are solely at the discretion of the relevant government department. Information on this website is provided for general guidance and does not constitute legal, tax, or financial advice — please consult with us directly for advice specific to your situation.',
  },
  {
    title: 'Governing Law',
    body: 'These terms are governed by the laws of India, and any disputes will be subject to the jurisdiction of the courts in Purulia, West Bengal.',
  },
];

export default function Terms() {
  return (
    <>
      <SEOHead
        title="Terms & Conditions, Privacy Policy, Refund Policy & Disclaimer — Bharat Consultancy"
        description="Terms of service, privacy policy, refund policy and disclaimer for Bharat Consultancy's tax filing, registration, and compliance services."
        canonicalPath="/terms"
        jsonLd={buildBreadcrumbSchema([
          { name: 'Home', url: 'https://bharat-consultancy.com/' },
          { name: 'Terms & Privacy', url: 'https://bharat-consultancy.com/terms' },
        ])}
      />

      <section className="border-b border-line bg-paper py-12">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Legal</p>
          <h1 className="mt-2 font-display text-3xl font-bold text-ink">
            Terms &amp; Conditions, Privacy Policy, Refund Policy &amp; Disclaimer
          </h1>
          <p className="mt-3 text-ink/65">
            Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long' })}. Please read
            this before using Bharat Consultancy's services.
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-3xl space-y-10 px-4 py-12 sm:px-6">
        {SECTIONS.map((section) => (
          <section key={section.title}>
            <h2 className="font-display text-xl font-bold text-ink">{section.title}</h2>
            <p className="mt-3 leading-relaxed text-ink/75">{section.body}</p>
          </section>
        ))}

        <section className="rounded-lg border border-line bg-white p-6">
          <h2 className="font-display text-lg font-bold text-ink">Questions About These Terms?</h2>
          <p className="mt-2 text-sm leading-relaxed text-ink/65">
            Contact us at{' '}
            <a href="tel:+918170896296" className="font-medium text-seal-blue">
              81708 96296
            </a>{' '}
            or visit us at 2nd Floor, Aradhya Complex, SN Sarkar St, Munsifdanga, Purulia, West Bengal 723101.
          </p>
        </section>
      </div>
    </>
  );
}
